import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from 'components/layout/Page';
import Faqs from 'components/marketingSite/shared/Faqs';
import { ButtonLink } from 'components/shared/ButtonLink';
import { useI18n } from 'hooks/useI18n';
import {
  StyledContainer,
  StyledFaqsActions
} from './PrivacyPolicyComponent.styled';
import PrivacyPolicyData from './PrivacyPolicyData';
import PrivacyPolicyDetails from './PrivacyPolicyDetails';
import PrivacyPolicyFeatures from './PrivacyPolicyFeatures';
import PrivacyPolicyHero from './PrivacyPolicyHero';

const PrivacyPolicyComponent: React.FC = () => {
  const { t } = useI18n('privacyPolicy');
  const glossary = [
    {
      question: t('glosary.glosary1.question'),
      answer: t('glosary.glosary1.answer')
    },
    {
      question: t('glosary.glosary2.question'),
      answer: t('glosary.glosary2.answer')
    },
    {
      question: t('glosary.glosary3.question'),
      answer: t('glosary.glosary3.answer')
    },
    {
      question: t('glosary.glosary4.question'),
      answer: t('glosary.glosary4.answer')
    },
    {
      question: t('glosary.glosary5.question'),
      answer: t('glosary.glosary5.answer')
    },
    {
      question: t('glosary.glosary6.question'),
      answer: t('glosary.glosary6.answer')
    },
    {
      question: t('glosary.glosary7.question'),
      answer: t('glosary.glosary7.answer')
    },
    {
      question: t('glosary.glosary8.question'),
      answer: t('glosary.glosary8.answer')
    },
    {
      question: t('glosary.glosary9.question'),
      answer: t('glosary.glosary9.answer')
    }
  ];
  return (
    <Page hasScrollTop>
      <StyledContainer>
        <PrivacyPolicyHero />
        <PrivacyPolicyData />
        <PrivacyPolicyFeatures />
        <Faqs faqs={glossary} title={t('glosary.title')} />
        <StyledFaqsActions>
          <ButtonLink href="https://drive.google.com/file/d/17WOXPUgKnF7Dfs6f2PMoV2udmcFi2Kys/view">
            <FontAwesomeIcon icon={faCloudDownload} />
            <span>{t('glosary.CTA.download')}</span>
          </ButtonLink>
          <ButtonLink
            href="https://github.com/getmanfred/privacy-policy"
            variant="secondary"
          >
            <FontAwesomeIcon icon={faGithub} />
            <span>{t('glosary.CTA.github')}</span>
          </ButtonLink>
        </StyledFaqsActions>
        <PrivacyPolicyDetails />
      </StyledContainer>
    </Page>
  );
};

export default PrivacyPolicyComponent;
